<!--
 * @Author: WGL 958897276@qq.com
 * @Date: 2025-06-16 17:36:15
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-06-25 14:06:08
 * @FilePath: /erp-admin/src/components/BaseFreezeStock/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-popover
    :persistent="false"
    placement="right"
    trigger="click"
    :width="600"
  >
    <template #reference>
      <span v-if="text" class="cp c0 tdu">{{ text }}</span>
      <jwt-icon v-else class="cp" icon="information-line" />
    </template>
    <BaseProductFreeze :scope="scope" />
  </el-popover>
</template>

<script>
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'BaseFreezeStock',
    props: {
      scope: { type: Object, default: () => {} },
      text: { type: String, default: '' },
    },
    setup() {
      return {}
    },
  })
</script>

<style scoped></style>
